import { render } from "./patent.vue?vue&type=template&id=77b3eef4"
import script from "./patent.vue?vue&type=script&lang=js"
export * from "./patent.vue?vue&type=script&lang=js"

import "./patent.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__